// extracted by mini-css-extract-plugin
module.exports = {"select":"DepOnline_select__2BrCp","row":"DepOnline_row__2yBaE","button":"DepOnline_button___XxIL","input":"DepOnline_input__3kOzf"};